import { render, staticRenderFns } from "./RequestPatientForm.vue?vue&type=template&id=20487c62&scoped=true&"
import script from "./RequestPatientForm.vue?vue&type=script&lang=js&"
export * from "./RequestPatientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20487c62",
  null
  
)

export default component.exports